import { Injectable, ErrorHandler } from '@angular/core';
import { Store } from '@ngrx/store';
import { AppState } from '@app/store/store.states';
// import { SnackbarOpen } from '@app/store/snackbar/snackbar.actions';
import { HideSpinner } from '@app/store/loading-spinner/loading-spinner.actions';
import { FeedbackDialogComponent } from '@app/theme/feedback-dialog/feedback-dialog.component';
import { MatDialog } from '@angular/material/dialog';

@Injectable({
  providedIn: 'root',
})
export class ErrorHandlerService extends ErrorHandler {
  DEFAULT_UNHANDLED_INTERFACE_ERROR_MESSAGE =
    'Um problema ocorreu, verifique sua conexão com a internet ou tente novamente mais tarde.';

  constructor(private readonly store: Store<AppState>, public dialog: MatDialog) {
    super();
  }

  handleError(error: any) {
    if (error.status !== 403) {
      // this.displayUserFriendlyErrorMessage();
    }

    this.stopStoreLoadingSpinners();

    super.handleError(error);
  }

  // displayUserFriendlyErrorMessage(
  //   interfaceErrorMessage: string = this.DEFAULT_UNHANDLED_INTERFACE_ERROR_MESSAGE
  // ) {
  //   this.openFeedbackDialog(
  //     'error',
  //     interfaceErrorMessage ? interfaceErrorMessage : 'Erro de conexão'
  //   );
  // }

  stopStoreLoadingSpinners() {
    this.store.dispatch(new HideSpinner());
  }

  openFeedbackDialog(color, message) {
    this.openDialog(FeedbackDialogComponent, {
      data: {
        color: color,
        message: message,
      },
    });
  }

  openDialog(dialogComponent, data = {}) {
    return this.dialog.open(dialogComponent, {
      data,
      panelClass: 'feedback-modalbox',
      disableClose: true,
    });
  }
}
